import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { BE_API_AUTH_URL, BE_API_URL } from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class TeamAccessService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  listUsers(): Observable<any> {
    return this.http
      .get(`${BE_API_AUTH_URL}/company/users`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  listInvites(): Observable<any> {
    return this.http
      .get(`${BE_API_AUTH_URL}/company/invites`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  createInvite(payload: { email: string; displayName?: string; companyRole: string; permissions: string[] }): Observable<any> {
    return this.http
      .post(`${BE_API_AUTH_URL}/company/invites`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  revokeInvite(inviteId: string): Observable<any> {
    return this.http
      .post(`${BE_API_AUTH_URL}/company/invites/${inviteId}/revoke`, {}, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateUser(userId: string, payload: { displayName?: string; companyRole?: string; permissions?: string[] }): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/company/users/${userId}`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateUserDeactivation(userId: string, isDeactivated: boolean): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/company/users/${userId}/deactivate`, { isDeactivated }, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  removeUser(userId: string): Observable<any> {
    return this.http
      .delete(`${BE_API_AUTH_URL}/company/users/${userId}`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  acceptInvite(payload: { token: string; password: string }): Observable<any> {
    return this.http
      .post(`${BE_API_URL}/company/invites/accept`, payload)
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
